import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://www.mareaa.online/cart/53202441404781:1';
export function SolutionSection() {
  return <section className="w-full bg-gradient-to-br from-primary to-primary-mid py-16 px-4 md:px-8" data-id="element-193">
      <div className="max-w-3xl mx-auto text-white" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-195">
          <p className="text-white/60 text-sm uppercase tracking-wider mb-3" data-id="element-196">
            📖 La Solución
          </p>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif mb-4 text-white" data-id="element-197">
            Te presento el Ebook "Cero Inflamación"
          </h2>

          <p className="text-lg text-white/80 mb-8 max-w-xl mx-auto" data-id="element-198">
            La guía práctica para desinflamar tu abdomen, mejorar tu digestión y
            sentirte liviana en pocos días.
          </p>

          <p className="text-white/70 mb-8 max-w-lg mx-auto text-sm" data-id="element-199">
            Una guía simple, directa y sin vueltas que te explica exactamente
            qué hacer, cómo hacerlo y por qué funciona.
          </p>

          <div className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-200">
            <p className="flex items-start gap-2 text-white/90 text-sm" data-id="element-201">
              <span className="mt-0.5" data-id="element-202">👉</span> No es una dieta más
            </p>
            <p className="flex items-start gap-2 text-white/90 text-sm" data-id="element-203">
              <span className="mt-0.5" data-id="element-204">👉</span> No es dejar de comer todo
            </p>
            <p className="flex items-start gap-2 text-white/90 text-sm font-semibold" data-id="element-205">
              <span className="mt-0.5" data-id="element-206">👉</span> Es entender tu cuerpo y atacar
              la causa real
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-5 rounded-xl mb-8 max-w-md mx-auto text-left" data-id="element-207">
            <div className="space-y-2" data-id="element-208">
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-209">
                <span className="text-accent-light mt-0.5" data-id="element-210">✓</span> Guía paso a
                paso fácil de aplicar
              </p>
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-211">
                <span className="text-accent-light mt-0.5" data-id="element-212">✓</span> Enfoque
                práctico desde el primer día
              </p>
              <p className="flex items-start gap-2 text-white text-sm" data-id="element-213">
                <span className="text-accent-light mt-0.5" data-id="element-214">✓</span> Diseñada
                para mujeres que ya probaron de todo
              </p>
            </div>
          </div>

          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold text-base md:text-lg px-10 py-5 rounded-full shadow-xl shadow-accent/30 transition-all duration-300" data-id="element-215">
            SÍ, QUIERO MI GUÍA CERO INFLAMACIÓN
            <ArrowRightIcon className="w-5 h-5" data-id="element-216" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}